export const environment = {
  production: false,
  env: 'Ambiente Pruebas Staging',
  apiUrl: 'https://gmemaapitest.clavisco.com/',
  reportManagerUrl: 'https://gmrpmapi.clavisco.com/',
  padronUrl: 'https://api.hacienda.go.cr/fe/'
};
  